/**
 * Implement a DEX trading history
 * How-to calculate a price?
 * Imagine pair WBTC/WETH
 * We got 3 coins for 10 coins, so price of 1 BTC is 10 coins / 3 coins
 */
import { useSelector } from 'react-redux';
import DexTrades from './DexTrades';
import Loading from '../common/Loader';
import { IStore } from '../../reducers';

import './styles.scss';

const DexTradesWrapper = () => {
  const kind = useSelector((state: IStore) => state.current.kind);

  return <DexTrades cex={kind == 1} />;
};

export const Loader = () => (
  <div className='loader__container'>
    <div className='loader__container__loader'>
      <Loading />
    </div>
  </div>
);

export default DexTradesWrapper;
